import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Carrossel de imagens reutilizável
 * Responsabilidade: Navegação entre imagens com dots indicator
 */
export default function ImageCarousel({ 
  images = [], 
  height = '240px',
  onImageChange 
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const defaultImages = ['https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80'];
  const imageList = images.length > 0 ? images : defaultImages;

  const goToNext = () => {
    const newIndex = (currentIndex + 1) % imageList.length;
    setCurrentIndex(newIndex);
    onImageChange?.(newIndex);
  };

  const goToPrev = () => {
    const newIndex = (currentIndex - 1 + imageList.length) % imageList.length;
    setCurrentIndex(newIndex);
    onImageChange?.(newIndex);
  };

  return (
    <div style={{ position: 'relative', width: '100%', height, marginBottom: '1.5rem' }}>
      {/* Imagem Principal */}
      <div style={{
        width: '100%',
        height: '100%',
        borderRadius: '1rem',
        backgroundImage: `url(${imageList[currentIndex]})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
      }} />

      {/* Botões de Navegação */}
      {imageList.length > 1 && (
        <>
          <button
            onClick={goToPrev}
            style={{
              position: 'absolute',
              left: '0.5rem',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(4px)',
              border: 'none',
              borderRadius: '50%',
              padding: '0.5rem',
              cursor: 'pointer',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <ChevronLeft size={20} strokeWidth={2.5} />
          </button>
          <button
            onClick={goToNext}
            style={{
              position: 'absolute',
              right: '0.5rem',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(4px)',
              border: 'none',
              borderRadius: '50%',
              padding: '0.5rem',
              cursor: 'pointer',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <ChevronRight size={20} strokeWidth={2.5} />
          </button>
        </>
      )}

      {/* Dots Indicator */}
      {imageList.length > 1 && (
        <div style={{
          position: 'absolute',
          bottom: '0.75rem',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '0.375rem'
        }}>
          {imageList.map((_, index) => (
            <div
              key={index}
              style={{
                width: currentIndex === index ? '20px' : '6px',
                height: '6px',
                borderRadius: '9999px',
                backgroundColor: currentIndex === index ? '#5DD4C3' : 'rgba(255, 255, 255, 0.5)',
                transition: 'all 0.2s'
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
